<script>
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  computed: {
    ...mapState('broilerAdmin/alerts', ['alerts']),
    ...mapGetters(['isTaskBusy', 'taskError']),
    ...mapGetters('auth', ['userHasRole']),

    userCanSeeAlerts() { return this.userHasRole('BroilerAdmin') || this.userHasRole('LayerAdmin') },

    busyLoading() { return this.isTaskBusy(`LOAD_ADMIN_ALERTS`) },
    errLoading() { return this.taskError(`LOAD_ADMIN_ALERTS`) },
    hasAlerts() { return this.userCanSeeAlerts && this.alerts.length > 0 },
    alertsRoute() { return { name: 'admin-alerts' } },
  },

  created() {
    if (this.userCanSeeAlerts && !this.busyLoading) {
      console.debug('Although used can see alerts, it has been disabled since it is only a Broiler feature')
      //this.LOAD_ADMIN_ALERTS();
    }
  },

  methods: {
    ...mapActions('broilerAdmin/alerts', ['LOAD_ADMIN_ALERTS']),
  },
}
</script>

<template>
  <div v-if="userCanSeeAlerts">
    <slot :busy="busyLoading" :error="errLoading" :hasAlerts="hasAlerts" :alerts="alerts" :alertsRoute="alertsRoute"></slot>
  </div>
</template>



// WEBPACK FOOTER //
// src/broilerAdmin/components/AdminAlertsLoader.vue